import CheckMarkIcon from "@assets/icons/check-mark.svg";
import { useOnceEffect } from "@core/hooks/use-once-effect";
import { useI18n } from "@core/i18n/i18n";
import { useNavigate } from "@core/routing/use-navigate";
import { HealthcareTeamInvitationPatientData } from "@domain/healthcare-team/healthcare-team-manager";
import { sendAnalyticsEventJoinPatientHealthcareTeam } from "@domain/patient/patient-analytics";
import styled from "@emotion/styled";
import { BackgroundIcon } from "@ui/components/common/background-icon";
import { Button } from "@ui/components/buttons/button";
import { RoutesPath } from "@ui/navigation/routes";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";

export const HealthcareTeamJoinedStep: React.FC<HealthcareTeamInvitationPatientData> = ({ fullname, id }) => {
	const { format } = useI18n();
	const navigate = useNavigate();

	useOnceEffect(() => {
		sendAnalyticsEventJoinPatientHealthcareTeam(id);
	});

	return (
		<Container>
			<BackgroundIcon iconSvg={CheckMarkIcon} />
			<p className="p-size-m-bold">{format("home.addPatientDialog.hctJoined.title", { patientName: fullname })}</p>
			<p className="p-size-m" style={{ color: colors.grey }}>
				{format("home.addPatientDialog.hctJoined.subtitle")}
			</p>
			<Button
				label={format("home.addPatientDialog.hctJoined.cta")}
				onClick={() =>
					navigate(RoutesPath.PatientDetails, {
						route: {
							patientId: id,
						},
					})
				}
			/>
		</Container>
	);
};

const Container = styled.div`
	margin-top: 8px;
	${stack("L", "center", "center")}
	text-align: center;
`;
